import angular from 'angular';
import uiRouter from 'angular-ui-router';
import jobRequestsComponent from './job-requests.component';

let jobRequestsModule = angular.module('app.containers.job-requests', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('jobRequests', {
      url: '/job-requests',
      template: '<job-requests></job-requests>'
    });
})

.component('jobRequests', jobRequestsComponent);

export default jobRequestsModule;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/job-requests/job-requests.js
 **/